<template>
  <b-row>
    <b-col cols="12" class="mb-5">
      <PageTitle title="Lista de pedidos" />
    </b-col>

    <b-col cols="12" class="mt-3">
      <PeriodsFilters
        ref="periodsFilters"
        :setDatesAutomatic="false"
        :startDate.sync="filters.startDate"
        :endDate.sync="filters.endDate"
        @click.native="get()"
      />
    </b-col>

    <b-col cols="12" class="mt-4 mb-4">
      <input
        type="text"
        class="form-control"
        v-model="filters.name"
        placeholder="Digite o nome da loja ou responsável"
        @input="searchTimeOut"
      />
    </b-col>
    <b-col cols="12">
      <label>Status</label>
      <div>
        <h4>
          <b-badge
            :variant="
              filters.status.includes(APP_SOLICITATION_STATUS[key])
                ? 'primary'
                : 'light'
            "
            class="pointer mr-2"
            v-for="(key, index) in Object.keys(APP_SOLICITATION_STATUS)"
            :key="index"
            @click="addSolicitationStatus(APP_SOLICITATION_STATUS[key])"
          >
            {{ getSolicitationText(APP_SOLICITATION_STATUS[key]) }}
          </b-badge>
          <b-badge
            :variant="
              filters.status.length ===
              Object.keys(APP_SOLICITATION_STATUS).length
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addAllTypes()"
          >
            Todos
          </b-badge>
        </h4>
      </div>
    </b-col>
    <b-col cols="12" class="mt-4">
      <b-button variant="success" @click="get()" :disabled="loading">
        <i class="fas fa-search mr-2"></i>
        Pesquisar
      </b-button>
      <b-button variant="warning" class="ml-2" @click="filters = {}">
        <i class="fas fa-trash mr-2"></i>
        Limpar
      </b-button>
    </b-col>
    <b-col class="mt-5 mb-2 d-flex align-items-center justify-content-between">
      <h3 class="title font-weight-bold">
        Encontrado(s) {{ table.records.length }} lojista(s) no total
      </h3>
      <b-button
        v-if="!generatingSpreadsheet"
        pill
        variant="success"
        @click="generateSpreadsheet()"
      >
        <i class="fas fa-file-download mr-2"></i>
        Baixar planilha
      </b-button>
    </b-col>
    <b-col cols="12" class="mt-4">
      <b-table
        striped
        responsive
        hover
        :fields="table.headers"
        :items="table.records"
        :busy="loading"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>
        <template #cell(created_at)="data">
          {{ dataFormat(data.value) }}
        </template>
        <template #cell(razao_social)="data">
          {{ data.item.razao_social }} - {{ data.item.usuario_id }}
        </template>
        <template #cell(assinatura)="data">
          {{ data.item.assinatura == true ? 'Paga' : 'Grátis' }}
          <span class="cursor-pointer ml-2" @click="alterarStatus(data.item)">
            <i class="fas fa-sync"></i>
          </span>
        </template>
        <template #cell(status)="data">
          <v-select
            v-if="statusActive == data.index"
            class="select"
            v-model="data.item.status"
            :options="optionStatus"
            :loading="loading"
          >
          </v-select>
          <span v-else>
            {{
              data.item.status == 1 ? "1 - Em demonstração" : ""  ||
              data.item.status == 2 ? "2 - Demonstração finalizada" : ""  ||
              data.item.status == 3 ? "3 - Aguardando customização" : "" ||
              data.item.status == 4 ? "4 - Pedido de envio" : ""  ||
              data.item.status == 5 ? "5 - App enviado" : ""  ||
              data.item.status == 6 ? "6 - App disponível" : "" ||
              data.item.status == 7 ? "7 - App confirmado pelo lojista" : ""
            }}
          </span>
        </template>
        <template #cell(actions)="data">
          <b-col style="width: 180px" class="pr-0">
            <!-- <b-btn
              @click="dadosFacebookAds(data.item.usuario_id)"
              variant="info"
              v-b-tooltip.hover
              title="Dados de configuração do facebook ADS"
              size="sm"
              class="mr-2 mb-2"
            >
              <i class="fas fa-comment-dollar"></i>
            </b-btn> -->

            <b-btn
              @click="dadosAssinatura(data.item.lojista_id, data.item.usuario_id)"
              variant="success"
              v-b-tooltip.hover
              title="Alterar assinatura do lojista"
              size="sm"
              class="mr-2 mb-2"
            >
              <i class="fas fa-money-check"></i>
            </b-btn>

            <b-btn
              @click="
                $refs.shopkeeperDetailsWithApp.toggleOpen({
                  shopkeeperId: data.item.usuario_id,
                  dadosLojista: data.item,
                })
              "
              variant="warning"
              v-b-tooltip.hover
              title="Ver dados do lojista"
              size="sm"
              class="mr-2 mb-2"
            >
              <i class="fas fa-eye"></i>
            </b-btn>

            <b-btn
              v-if="statusEdit != data.index"
              @click="showSelect(data.index)"
              variant="primary"
              v-b-tooltip.hover
              title="Editar registro"
              class="mb-2"
              size="sm"
            >
              <i class="fa fa-pen"></i>
            </b-btn>
            <b-btn
              v-else
              @click="editStatus(data.item)"
              variant="success"
              v-b-tooltip.hover
              title="Salvar"
              class="mb-2"
              size="sm"
            >
              <i class="fa fa-check"></i>
            </b-btn>
            <b-btn
              @click="updateAgentIa(data.item.lojista_id, !data.item.agent_ia), data.item.agent_ia = !data.item.agent_ia"
              :variant="data.item.agent_ia ? 'success' : 'danger'"
              v-b-tooltip.hover
              :title="data.item.agent_ia ? 'Está mostrando o Agente IA' :  'Não está mostrando o Agente IA'"
              size="sm"
              class="ml-2 mb-2"
            >
              <i class="fas fa-robot"></i>
            </b-btn>
          </b-col>
        </template>
      </b-table>
    </b-col>
    <b-col cols="12" class="d-flex align-items-center justify-content-center">
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.itemsPerPage"
        :disabled="loading"
        aria-controls="selectProductsTable"
      ></b-pagination>
    </b-col>

    <ShopkeeperDetailsWithApp ref="shopkeeperDetailsWithApp" />

    <b-modal
      title="Links das lojas do app"
      size="md"
      id="modal-link-store"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
     <div class="row">
      <div class="col-12">
        <label>Loja:</label>
        <input type="text" class="form-control" v-model="lojaUp.nome_fantasia" disabled>
      </div>

      <div class="col-12">
        <label>Link loja Android:</label>
        <input type="text" class="form-control" v-model="link.android">
      </div>

      <div class="col-12">
        <label>Link loja Apple:</label>
        <input type="text" class="form-control" v-model="link.apple">
      </div>

      <div class="col-12 text-center mt-4">
        <button class="btn btn-success"  @click="editStatus(lojaUp)">Salvar</button>
      </div>
     </div>
    </b-modal>

    <b-modal
      title="Dados da api para o Facebook Ads"
      size="lg"
      id="modal-facebook-ads"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
     <div class="row">
      <div class="col-6">
        <label>ID do Aplicativo:</label>
        <input type="text" class="form-control" v-model="facebook.client_id">
      </div>

      <div class="col-6">
        <label>Chave Secreta do Aplicativo:</label>
        <input type="text" class="form-control" v-model="facebook.client_secret">
      </div>

      <div :class="facebook.expires_in != '' ? 'col-9 mt-2' : 'col-12 mt-2'">
        <label>Token de acesso:</label>
        <input type="text" class="form-control" v-model="facebook.fb_exchange_token">
      </div>

      <div class="col-3 mt-2" v-if="facebook.expires_in != ''">
        <label>Expiração do token:</label>
        <input type="date" class="form-control" v-model="facebook.expires_in" disabled>
      </div>

      <div class="col-12 text-center mt-4">
        <button class="btn btn-success"  @click="salvarFacebookAds()">Salvar</button>
      </div>
     </div>
    </b-modal>

    <b-modal
      title="Assinatura externa para o lojista"
      size="lg"
      id="modal-assinatura-externa"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
     <div class="row">
      <div class="col-12 mb-2">
        <label>Assinatura com a IUGU?:</label><br>
        <input type="checkbox" style="width: 30px; height: 30px" v-model="assinatura.iugu">
      </div>
     </div>

     <div class="row" v-if="assinatura.iugu == false">
      <div class="col-12 mb-2">
        <label>Planos</label>
        <select class="form-control" v-model="planoId">
          <option value="">-- Selecione o plano -- </option>
          <option v-for="(item, i) in planos" :key="i" :value="item.id">
            {{ item.nome }} / {{ item.preco_text }}
          </option>
        </select>
      </div>

      <div class="col-12 mb-2" v-if="planoId != ''">
        <label>Planos</label>
        <select class="form-control" v-model="cupomId">
          <option value="">-- Selecione os dados do plano -- </option>
          <option v-for="(item, i) in selectedCupons" :key="i" :value="item.id">
            Cupom: {{ item.cupom }} / Tempo contrato: {{ item.tempo_contrato_texto }} meses
          </option>
        </select>
      </div>

      <div class="col-4 mb-2" v-if="cupomId != ''">
        <label>Data do início do pagamento?</label>
        <input type="date" class="form-control" v-model="dataPagamento" :min="minDate">
      </div>

      <div class="col-12 mb-4 mt-2" v-if="assinatura.pagamentos && assinatura.pagamentos.assinatura_externa">
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Fatura ID</th>
              <th>Valor R$</th>
              <th>Fatura criada</th>
              <th>Fatura paga</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in assinatura.pagamentos.assinatura_externa" :key="i">
              <td>{{ item.fatura_id }}</td>
              <td>{{ formatMoney(item.valor) }}</td>
              <td>{{ item.fatura_criada }}</td>
              <td>{{ item.data_pagamento }}</td>
              <td v-if="item.status == 'AWAITING_PAYMENT'"><span class="badge badge-warning">Aguardando pagamento</span></td>
              <td v-else-if="item.status == 'PAID'"><span class="badge badge-success">Pagamento aprovado</span></td>
              <td v-else-if="item.status == 'CANCELED'"><span class="badge badge-danger">Pagamento cancelado</span></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-12 text-center mb-2" v-if="dataPagamento != ''">
        <button class="btn btn-success pl-4 pr-4" @click="atualizarAssinatura()">Salvar</button>
      </div>
     </div>
    </b-modal>
  </b-row>
</template>

<script>
import * as XLSX from 'xlsx';

import makeToast from 'Mixins/makeToast';

import APP_SOLICITATION_STATUS, {
  getText as getSolicitationText,
} from 'Enums/AppSolicitiation/AppSolicitationStatus.js';

import PageTitle from 'Components/PageTitle.vue';
import ShopkeeperDetailsWithApp from 'Components/Shopkeeper/ShopkeeperDetailsWithApp.vue';
import PeriodsFilters from '@/components/Inputs/PeriodsFilters.vue';

export default {
  mixins: [makeToast],
  name: 'ShopkeeperAppSolicitations',
  components: {
    PageTitle,
    ShopkeeperDetailsWithApp,
    PeriodsFilters,
  },
  data() {
    return {
      APP_SOLICITATION_STATUS,
      loading: false,
      planoId: '',
      cupomId: '',
      dataPagamento: '',
      generatingSpreadsheet: false,
      filters: {
        name: '',
        status: [],
        startDate:'',
        endDate: '',
      },
      facebook: {
        client_id: '',
        client_secret: '',
        fb_exchange_token: '',
        expires_in: '',
        usuario_id: ''
      },
      optionStatus: ['1 - Em demonstração', '2 - Demonstração finalizada', '3 - Aguardando customização', '4 - Pedido de envio', '5 - App enviado', '6 - App disponível', '7 - App confirmado pelo lojista'],
      optionAssinatura: [{ label: 'Assinatura paga', value: 1 }, { label: 'Assinatura grátis', value: 0 }],
      pagination: {
        currentPage: 1,
        itemsPerPage: 1,
        total: 0,
      },
      table: {
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'shopkeeperId',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'created_at',
            label: 'Data',
            sortable: true,
          },
          {
            key: 'razao_social',
            label: 'Empresa',
            sortable: true,
          },
          {
            key: 'cnpj',
            label: 'CNPJ',
            sortable: true,
          },
          {
            key: 'email',
            label: 'E-mail',
            sortable: true,
          },
          {
            key: 'assinatura',
            label: 'Assinatura',
            sortable: true,
          },
          {
            key: 'status',
            label: 'Status',
            sortable: true,
          },
          {
            key: 'actions',
            label: 'Ações',
            thClass: 'text-center',
            tdClass: 'text-center',
          },
        ],
        records: [],
      },
      statusActive: null,
      statusEdit: null,
      response: 0,
      data: {
        lojista_id: null,
      },
      link: {
        android: '',
        apple: ''
      },
      lojaUp: [],
      timer: null,
      usuarioId: null,
      lojistaId: null,
      minDate: null,
      assinatura: {},
      planos: [],
    };
  },
  computed: {
    selectedCupons() {
      if (!this.planoId) return [];
      const selectedPlano = this.planos.find(plano => plano.id === parseInt(this.planoId));
      return selectedPlano ? selectedPlano.assinatura_cupom : [];
    }
},
  created() {
    this.get();
  },
  methods: {
    getSolicitationText,
    formatMoney(value) {
      var money = parseFloat(value);
      var moneyConvert = money / 100;
      return moneyConvert.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    },
    calculateMinDate() {
      const today = new Date();
      const day = today.getDate().toString().padStart(2, '0');
      const month = (today.getMonth() + 1).toString().padStart(2, '0');
      const year = today.getFullYear();
      return `${year}-${month}-${day}`;
    },
    updateAgentIa(lojista_id, agent_ia) {
      const data = {
        lojista_id: lojista_id,
        agent_ia: agent_ia
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/udpateStatusAgentIa', data)
        .then((response) => {
          if(response.data.error) {
            this.makeToast('Ops!', 'Ocorreu um erro ao atualizar!', 'danger');
          } else {
            this.makeToast('Sucesso', 'Assinatura atualizada com sucesso!', 'success');
          }
        })
        .catch(() => {
          this.makeToast('Ops!', 'Ocorreu um erro ao atualizar!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    atualizarAssinatura() {
      const data = {
        usuarioId: this.usuarioId,
        lojistaId: this.lojistaId,
        planoId: this.planoId,
        cupomId: this.cupomId,
        dataPagamento: this.dataPagamento
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/atualizarDadosAssinatura', data)
        .then((response) => {
          if(response.data.error) {
            this.makeToast('Ops!', 'Ocorreu um erro ao atualizar assinatura!', 'danger');
          } else {
            this.makeToast('Sucesso', 'Assinatura atualizada com sucesso!', 'success');
            this.$bvModal.hide('modal-assinatura-externa');
          }

        })
        .catch(() => {
          this.makeToast('Ops!', 'Ocorreu um erro ao atualizar assinatura!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    dadosFacebookAds(usuarioId) {
        this.facebook.client_id = '';
        this.facebook.client_secret = '';
        this.facebook.fb_exchange_token = '';
        this.facebook.expires_in = '';

      this.facebook.usuario_id = usuarioId;

      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/getDadosFacebookAds', usuarioId)
        .then((response) => {
          if(response.data.usuario_id) {
            this.facebook = response.data;
          }

          this.$bvModal.show('modal-facebook-ads');
        })
        .catch(() => {
          this.makeToast('Ops!', 'Ocorreu um erro ao buscar informações!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    salvarFacebookAds() {
      if(this.facebook.client_id == '') {
        this.makeToast('Ops!', 'Informe o ID do Aplicativo para continuar!', 'danger');
        return;
      }

      if(this.facebook.client_secret == '') {
        this.makeToast('Ops!', 'Informe a Chave Secreta do Aplicativo para continuar!', 'danger');
        return;
      }

      if(this.facebook.fb_exchange_token == '') {
        this.makeToast('Ops!', 'Informe o Token de acesso para continuar!', 'danger');
        return;
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/saveDadosFacebookAds', this.facebook)
        .then((response) => {
          if(response.data.error) {
            this.makeToast('Ops!', 'Ocorreu um erro ao salvar dados do Facebook Ads!', 'danger');
          } else {
            this.makeToast('Sucesso!', 'Dados do Facebook Ads salvo com sucesso!', 'success');
            this.$bvModal.hide('modal-facebook-ads');
          }
        })
        .catch(() => {
          this.makeToast('Ops!', 'Ocorreu um erro ao salvar dados do Facebook Ads!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    dadosAssinatura(lojistaId, usuarioId) {
      this.usuarioId = usuarioId;
      this.lojistaId = lojistaId;

      const data = {
        lojistaId: lojistaId,
        usuarioId: usuarioId
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/getDadosAssinatura', data)
        .then((response) => {
          this.minDate = this.calculateMinDate();

          this.assinatura = response.data.assinatura;
          this.planos = response.data.planos;

          if(this.assinatura.iugu == false) {
            this.minDate = null;
            this.dataPagamento = this.assinatura.pagamentos.data_adesao;
            this.planoId = this.assinatura.pagamentos.plano_id;
            this.cupomId = this.assinatura.cupom_id;
          }

          this.$bvModal.show('modal-assinatura-externa');
        })
        .catch(() => {
          this.makeToast('Ops!', 'Ocorreu um erro ao buscar informações!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    alterarStatus(loja) {
      let data = {
        lojista_id: loja.lojista_id,
        assinatura: !loja.assinatura,
      };

      this.$store.dispatch('startLoader');
      this.$store.dispatch('alterarAssinaturaPagamento', data)
        .then((response) => {
          if(response.data.error == true) {
            this.makeToast('Ops!', response.data.message, 'danger');
          } else {
            this.makeToast('Sucesso', response.data.message, 'success');
            this.get();
          }
        })
        .catch(() => {
          this.makeToast('Ops!', 'Infelizmente ocorreu um erro, favor tentar novamente!!!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.timer = setTimeout(() => {
        this.get();
      }, 800);
    },
    addSolicitationStatus(userType) {
      if (this.filters.status.includes(userType)) {
        const index = this.filters.status.indexOf(userType);
        this.filters.status.splice(index, 1);
        this.get();
        return;
      }

      this.filters.status.push(userType);
      this.get();
    },
    addAllTypes() {
      Object.values(APP_SOLICITATION_STATUS).forEach((value) => {
        if (this.filters.status.includes(value)) return;

        this.filters.status.push(value);
      });

      this.get();
    },
    showSelect(index) {
      this.statusEdit = index;
      this.statusActive = index;
    },
    editStatus(index) {
      if(index.status[0] == 6 && this.link.android == '' && this.link.apple == '') {
        this.lojaUp = index;
        this.$bvModal.show('modal-link-store');
        return;
      } else {
        this.$bvModal.hide('modal-link-store');
      }

      let objData = {
        id: index.lojista_id,
        status: index.status[0],
        android: this.link.android,
        apple: this.link.apple
      };

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('updateShopkeeperStatus', objData)
        .then(() => {
          this.statusEdit = null;
          this.get();
        })
        .catch((error) => {
          this.makeToast(
            'Ops!',
            'Infelizmente ocorreu um erro, favor tentar novamente!!!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.statusActive = null;
          this.statusEdit = null;
          this.link.android = '';
          this.link.apple = '';
          this.lojaUp = [];
        });
    },

    get() {
      this.loading = true;

      const request = {
        status: this.filters.status || [],
        startDate: this.filters.startDate || '',
        endDate:this.filters.endDate || '',
      };

      this.$store
        .dispatch('listarTodasSolicitacoesApp', request)
        .then((response) => {
          this.table.records = response.data || [];
        })
        .catch(() => {
          this.makeToast(
            'Opa!',
            'Infelizmente ocorreu um erro, favor tentar novamente!',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    generateSpreadsheet() {
      this.generatingSpreadsheet = true;

      const shopkeepersData = XLSX.utils.json_to_sheet(
        this.convertColumnsNames(this.table.records)
      );

      const excelFile = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(
        excelFile,
        shopkeepersData,
        'Lista de lojistas'
      );

      const currentDate = new Date().toLocaleDateString('pt-BR');
      const fileName = `Lista de lojistas que solicitaram o APP - ${currentDate}`;

      setTimeout(() => {
        this.generatingSpreadsheet = false;
      }, 1000);

      XLSX.writeFile(excelFile, `${fileName}.xlsx`);
    },
    /**
     * @param {Array} records
     * @returns {Array}
     */
    convertColumnsNames(records) {
      if (!records || !records.length) return [];

      const returnArray = [];

      records.forEach((record) => {
        const cell = {};

        Object.keys(record).forEach((key) => {
          const tableColumn = this.table.headers.find((x) => x.key === key);

          if (!tableColumn) return;

          cell[`${tableColumn.label}`] = record[key];
        });

        returnArray.push(cell);
      });

      return returnArray;
    },
    dataFormat(value){
      const dia = value.slice(8,10);
      const mes =  value.slice(5,7);
      const ano = value.slice(0,4);
      const hora = value.slice(11,19);
      return `${dia}/${mes}/${ano} - ${hora}`;
    }
  },
};
</script>
